const CNV_TYPES = {
  Duplication: "DUP",
  DUP: "DUP",
  duplication: "DUP",
  "<dup>": "DUP",
  dup: "DUP",
  triplication: "DUP",
  "duplication/triplication": "DUP",
  "copy-number gain": "DUP",
  "copy number gain": "DUP",
  gain: "DUP",
  mcnv: "DUP",

  del: "DEL",
  "<del>": "DEL",
  loss: "DEL",
  "line1 deletion": "DEL",
  "del:me": "DEL",
  "<del:me>": "DEL",
  "alu deletion": "DEL",
  "sva deletion": "DEL",
  "herv deletion": "DEL",
  "copy number loss": "DEL",
  "copy-number loss": "DEL",
  DEL: "DEL",
  deletion: "DEL",
  Deletion: "DEL",
};

export default CNV_TYPES;
